import React from 'react';
import {
  RouteComponentProps,
  Switch,
  Route,
  Link,
  useRouteMatch,
} from 'react-router-dom';

import paths from '../constants/routes.json';
import AccountProfile from './Account/Profile';
import AccountBilling from './Account/Billing';
import AccountIntegrations from './Account/Integrations';
import AccountSettings from './Account/Settings';
import AccountTeam from './Account/Team';
import AccountPassword from './Account/Password';
import useAuth from '../hooks/useAuth';
import { gql, useQuery } from '@apollo/client';
import { Account_AccountData } from '../types/graph/Account_AccountData';
import { ViewGridAddIcon, CreditCardIcon } from '@heroicons/react/outline';

interface IProps extends RouteComponentProps {}

const Account: React.FC<IProps> = () => {
  const { getAccountId } = useAuth();

  const { data, loading } = useQuery<Account_AccountData>(GET_ACCOUNT, {
    variables: { accountId: getAccountId() },
  });

  return (
    <div>
      <main className="relative">
        <div className="max-w-screen-xl mx-auto pb-6 px-4 sm:px-6 lg:pb-16 lg:px-8">
          <div className="overflow-hidden">
            <div className="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
              <aside className="py-6 lg:col-span-2">
                <nav>
                  {/* Current: "bg-sky-50 border-sky-500 text-sky-700 hover:bg-sky-50 hover:text-sky-700", Default: "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900" */}
                  <Link
                    to={paths.ACCOUNT_PROFILE}
                    className={`${
                      useRouteMatch({
                        path: paths.ACCOUNT_PROFILE,
                        exact: true,
                      })
                        ? ` bg-sky-50 border-sky-500 text-sky-700 hover:bg-sky-50 hover:text-sky-700 `
                        : `border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900`
                    } rounded-l-lg group border-l-4 px-3 py-2 flex items-center text-sm font-medium`}
                    aria-current="page"
                  >
                    {/* Current: "text-sky-500 group-hover:text-sky-500", Default: "text-gray-400 group-hover:text-gray-500" */}
                    {/* Heroicon name: outline/user-circle */}
                    <svg
                      className={`${
                        useRouteMatch({
                          path: paths.ACCOUNT_PROFILE,
                          exact: true,
                        })
                          ? `text-sky-500 group-hover:text-sky-500`
                          : `text-gray-400 group-hover:text-gray-500`
                      } flex-shrink-0 -ml-1 mr-3 h-6 w-6`}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span className="truncate">Profile</span>
                  </Link>
                  {/* <Link
                    to={paths.ACCOUNT_SETTINGS}
                    className={`${
                      useRouteMatch(paths.ACCOUNT_SETTINGS)
                        ? ` bg-sky-50 border-sky-500 text-sky-700 hover:bg-sky-50 hover:text-sky-700 `
                        : `border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900`
                    } rounded-l-lg group border-l-4 px-3 py-2 flex items-center text-sm font-medium`}
                  >
                    Heroicon name: outline/cog
                    <svg
                      className={`${
                        useRouteMatch({
                          path: paths.ACCOUNT_SETTINGS,
                        })
                          ? `text-sky-500 group-hover:text-sky-500`
                          : `text-gray-400 group-hover:text-gray-500`
                      } flex-shrink-0 -ml-1 mr-3 h-6 w-6`}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                    <span className="truncate">Account</span>
                  </Link> */}
                  <Link
                    to={paths.ACCOUNT_TEAM}
                    className={`${
                      useRouteMatch(paths.ACCOUNT_TEAM)
                        ? ` bg-sky-50 border-sky-500 text-sky-700 hover:bg-sky-50 hover:text-sky-700 `
                        : `border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900`
                    } rounded-l-lg group border-l-4 px-3 py-2 flex items-center text-sm font-medium`}
                  >
                    {/* <!-- Heroicon name: outline/users --> */}
                    <svg
                      className={`${
                        useRouteMatch({
                          path: paths.ACCOUNT_TEAM,
                        })
                          ? `text-sky-500 group-hover:text-sky-500`
                          : `text-gray-400 group-hover:text-gray-500`
                      } flex-shrink-0 -ml-1 mr-3 h-6 w-6`}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      />
                    </svg>

                    <span className="truncate">Team</span>
                  </Link>
                  <Link
                    to={paths.ACCOUNT_PASSWORD}
                    className={`${
                      useRouteMatch(paths.ACCOUNT_PASSWORD)
                        ? ` bg-sky-50 border-sky-500 text-sky-700 hover:bg-sky-50 hover:text-sky-700 `
                        : `border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900`
                    } rounded-l-lg group border-l-4 px-3 py-2 flex items-center text-sm font-medium`}
                  >
                    {/* Heroicon name: outline/key */}
                    <svg
                      className={`${
                        useRouteMatch({
                          path: paths.ACCOUNT_PASSWORD,
                        })
                          ? `text-sky-500 group-hover:text-sky-500`
                          : `text-gray-400 group-hover:text-gray-500`
                      } flex-shrink-0 -ml-1 mr-3 h-6 w-6`}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
                      />
                    </svg>
                    <span className="truncate">Password</span>
                  </Link>
                  {/* <a
                    href="#tmp"
                    className="border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900 group mt-1 border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                  >
                    
                    <svg
                      className="text-gray-400 group-hover:text-gray-500 flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                      />
                    </svg>
                    <span className="truncate">Notifications</span>
                  </a> */}
                  <Link
                    to={paths.ACCOUNT_BILLING}
                    className={`${
                      useRouteMatch(paths.ACCOUNT_BILLING)
                        ? ` bg-sky-50 border-sky-500 text-sky-700 hover:bg-sky-50 hover:text-sky-700 `
                        : `border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900`
                    } rounded-l-lg group border-l-4 px-3 py-2 flex items-center text-sm font-medium`}
                  >
                    <CreditCardIcon
                      className={`${
                        useRouteMatch({
                          path: paths.ACCOUNT_BILLING,
                        })
                          ? `text-sky-500 group-hover:text-sky-500`
                          : `text-gray-400 group-hover:text-gray-500`
                      } flex-shrink-0 -ml-1 mr-3 h-6 w-6`}
                    />
                    <span className="truncate">Billing</span>
                  </Link>
                  <Link
                    to={paths.ACCOUNT_INTEGRATIONS}
                    className={`${
                      useRouteMatch(paths.ACCOUNT_INTEGRATIONS)
                        ? ` bg-sky-50 border-sky-500 text-sky-700 hover:bg-sky-50 hover:text-sky-700 `
                        : `border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900`
                    } rounded-l-lg group border-l-4 px-3 py-2 flex items-center text-sm font-medium`}
                  >
                    <ViewGridAddIcon
                      className={`${
                        useRouteMatch({
                          path: paths.ACCOUNT_INTEGRATIONS,
                        })
                          ? `text-sky-500 group-hover:text-sky-500`
                          : `text-gray-400 group-hover:text-gray-500`
                      } flex-shrink-0 -ml-1 mr-3 h-6 w-6`}
                    />

                    <span className="truncate">Integrations</span>
                  </Link>
                </nav>
              </aside>
              <div className="lg:col-span-9">
                {data?.account && (
                  <Switch>
                    <Route exact path={paths.ACCOUNT_PROFILE}>
                      <AccountProfile account={data.account} />
                    </Route>
                    {/* <Route
                      path={paths.ACCOUNT_SETTINGS}
                      component={AccountSettings}
                    /> */}
                    <Route path={paths.ACCOUNT_TEAM}>
                      <AccountTeam account={data.account} />
                    </Route>
                    <Route path={paths.ACCOUNT_PASSWORD}>
                      <AccountPassword account={data.account} />
                    </Route>
                    <Route path={paths.ACCOUNT_BILLING}>
                      <AccountBilling account={data.account} />
                    </Route>
                    <Route path={paths.ACCOUNT_INTEGRATIONS}>
                      <AccountIntegrations account={data.account} />
                    </Route>
                  </Switch>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Account;

export const GET_ACCOUNT = gql`
  query Account_AccountData($accountId: String!) {
    account(accountId: $accountId) {
      id
      roles
      scope
      user {
        id
        username
        roles
        scope
        person {
          name {
            first
            last
            full
          }
          email
          phones {
            number
            type
          }
          socialLinks {
            url
            type
          }
          avatar {
            filePath
          }
        }
        company {
          name
          title
          socialLinks {
            url
            type
          }
          logo {
            filePath
          }
        }
        state {
          status
          setAt
        }
      }
      users {
        id
        username
        roles
        scope
        person {
          name {
            first
            last
            full
          }
          email
          phones {
            number
            type
          }
          socialLinks {
            url
            type
          }
          avatar {
            filePath
          }
        }
        company {
          name
          title
          socialLinks {
            url
            type
          }
          logo {
            filePath
          }
        }
        state {
          status
          setAt
        }
      }
      billing {
        stripe {
          productId
          package
        }
      }
      integrations {
        facebook {
          status
        }
      }
    }
  }
`;
